import { isApolloError } from 'apollo-client';

export const getAPIDisplayTitleAndMessage = (error: Error): { traceId?: string; title?: string; message: string } => {
  if (isApolloError(error)) {
    if (error.graphQLErrors && error.graphQLErrors[0]) {
      const graphqlError = error.graphQLErrors[0];
      if (graphqlError.extensions && graphqlError.extensions.exception) {
        const traceId = graphqlError.extensions?.traceId;
        if (graphqlError.extensions.exception.display) {
          return {
            title: graphqlError.extensions.exception.display.title,
            message: graphqlError.extensions.exception.display.message,
            traceId,
          };
        } else if (graphqlError.extensions.message) {
          return {
            message: graphqlError.extensions.message,
            traceId,
          };
        } else {
          return {
            message:
              'Please try <a href="/">logging in</a> again. If this issue continues, please contact Noble support.',
            traceId,
          };
        }
      } else if (graphqlError.message === 'Forbidden') {
        return {
          message: `You don't have permission to see this page.`,
        };
      } else if (graphqlError.message) {
        return {
          message: graphqlError.message,
        };
      }
    }
  }

  return {
    message: 'Something went wrong. Noble has been alerted. Please contact us if this issue continues.',
  };
};
